// Permission levels
// Default values pr. server configuration.
export enum Permission {
    None = 0,
    LoggedIn = .5,
    Employee = 1,
    SuperEmployee = 2,
    DepartmentAdmin = 4,
    SuperManager = 8,
    CompanyAdmin = 16,
    OrganizationAdmin = 32,
    SuperAdmin = 64,
}
